import { GET_LIKES } from '../constants/actionTypes';

export default (likes = [], action) => {
  switch (action.type) {
    case GET_LIKES:
    return action.payload;
    default:
      return likes;
  }
};